import React from 'react';
import { Text, Theme, i18n, tokens } from "@simplybenefits/sb-ui-library";
import CloseIcon from '@mui/icons-material/Close';
import store from '../redux/store';
import { useTheme } from '@mui/material/styles';
import Bounce from '@stahl.luke/react-reveal/Bounce';


/**
 * @param classes
 * @param children
 * @param left
 * @param right
 * @param close
 * @param show
 * @param title
 * @param customStyle
 * @returns {null|*}
 * @constructor
 */
const Tip = ({ children, left, right, close, show = true, title = i18n.t(tokens.titles.tip), customStyle = {} }) => {
    const theme = useTheme();
    if (!show) {
        return null;
    }

    const styles = {
        leftContainer: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            width: 280,
            minHeight: 100,
            height: 'auto',
            backgroundColor: '#FFF',
            boxShadow: "0 1px 2px rgba(0,0,0,.15)",
            borderRadius: 5,
            padding: 20,
            marginTop: 30,
            marginLeft: -390
        },
        rightContainer: {
            display: 'flex',
            flexDirection: 'column',
            position: 'absolute',
            width: 280,
            minHeight: 100,
            height: 'auto',
            backgroundColor: '#FFF',
            boxShadow: "0 1px 2px rgba(0,0,0,.15)",
            borderRadius: 5,
            padding: 20,
            marginTop: 30,
            marginLeft: 730
        },
        titleBlock: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row'
        },
        closeIcon: {
            color: Theme.colors.mediumLightGrey,
            cursor: 'pointer'
        },
        line: {
            width: '100%',
            height: 2,
            opacity: 0.5,
            backgroundColor: theme.palette.primary.main,
            margin: "10px auto"
        }
    };

    return (
        <Bounce left={ left } right={ right }>
            <div style={ left ? { ...styles.leftContainer, ...customStyle } : { ...styles.rightContainer, ...customStyle }}>
                <div style={ styles.titleBlock }>
                    <Text bold medium color={ store.getState().whitelabel.primaryColor || Theme.colors.skyBlue } customStyle={{ flex: 1 }}>
                        { title }
                    </Text>

                    <CloseIcon
                        style={ styles.closeIcon }
                        onClick={close}
                    />
                </div>

                <div style={styles.line}/>

                <Text tip small>
                    { children }
                </Text>
            </div>
        </Bounce>
    );
};

export default (Tip);